var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1374 32.0709L33.1948 28.8766",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0476 35.4721L30.1904 32.1399",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41068 28.2127C3.59225 26.4405 3.14209 24.5042 3.14209 22.4762L5.80875 1.48285L13.8519 8.34919C15.9465 7.57596 18.2493 7.14769 20.6659 7.14769H21.4278C23.8445 7.14769 26.1473 7.57596 28.2418 8.34919L36.285 1.48285L38.9516 22.4762C38.9516 24.5042 38.5015 26.4405 37.683 28.2127",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.396 35.4865C14.085 36.9561 17.2628 37.8048 20.6669 37.8048H21.4288C24.8329 37.8048 28.0107 36.9562 30.6997 35.4865",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 32.1398L8.85712 28.8076",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04688 35.4721L11.9041 32.1399",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1772 17.5372C11.1772 15.2183 7.08627 15.07 7.34259 18.4484C7.37668 18.8967 7.56466 19.3281 7.84957 19.7022L12.0529 24.1424L16.1797 19.8102C16.6378 19.3288 16.9087 18.7193 16.895 18.092C16.8267 15.0829 12.9027 15.3022 12.0519 17.5364",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3037 17.5372C29.3036 15.2183 25.2127 15.07 25.4691 18.4484C25.5031 18.8967 25.6911 19.3281 25.976 19.7022L30.1793 24.1424L34.3061 19.8102C34.7642 19.3288 35.0352 18.7193 35.0214 18.092C34.9532 15.0829 31.0292 15.3022 30.1784 17.5364",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8643 26.5598H23.9642",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2886 28.5607C13.2886 28.5607 19.0072 31.2285 20.9135 26.5598C22.8197 31.2285 28.8353 28.5287 28.8353 28.5287C28.8353 28.5287 26.8604 31.3384 26.2784 31.8851C23.333 34.6517 19.3862 34.4849 16.2549 31.96C15.5692 31.4071 13.2886 28.5607 13.2886 28.5607V28.5607Z",
    stroke: "#5671A6",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat2);
export default __webpack_public_path__ + "static/media/cat2.050efb235d9817ebf51224ee7869ea9c.svg";
export { ForwardRef as ReactComponent };